<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useSession } from "../api";
import { CloseIcon } from "../icons";
const props = defineProps<{
  value: unknown;
  label: string;
  dataset?: string;
  publicBase?: string;
  form?: string;
}>();
const session = useSession(),
  dialog = ref<HTMLDialogElement>(),
  trigger = ref<HTMLButtonElement>(),
  failed = ref(false);
const source = computed(() =>
  props.publicBase
    ? `${props.publicBase}/images/${props.value}`
    : props.dataset
      ? `/api/datasets/${props.dataset}/images/${props.value}?organization=${session.organization}${props.form ? "&form=" + props.form : ""}`
      : undefined,
);
watch(source, () => {
  failed.value = false;
  dialog.value?.close();
});
function close() {
  dialog.value?.close();
  trigger.value?.focus();
}
</script>
<template>
  <span v-if="!value">—</span>
  <span v-else-if="failed || !source" class="muted"
    >Billedet er ikke tilgængeligt</span
  >
  <span v-else class="image-value">
    <button
      ref="trigger"
      type="button"
      class="image-thumb"
      :aria-label="'Åbn billede: ' + label"
      @click="dialog?.showModal()"
    >
      <img :src="source" :alt="label" loading="lazy" @error="failed = true" />
    </button>
    <dialog
      ref="dialog"
      class="record-dialog image-dialog"
      :aria-label="label"
      @cancel.prevent="close"
    >
      <header class="section-heading">
        <h2>{{ label }}</h2>
        <button
          class="icon-button"
          type="button"
          aria-label="Luk billede"
          @click="close"
        >
          <CloseIcon :size="20" />
        </button>
      </header>
      <img :src="source" :alt="label" />
    </dialog>
  </span>
</template>
<style scoped lang="scss" src="../styles/components/ImageValue.scss"></style>
